import React, { useRef } from 'react'
import { useState } from 'react';
import { useEffect } from 'react'
import Fuse from 'fuse.js';
import Search from '../Search';
import styles from "./index.module.scss"
import logo1 from "../../assets/images/gjepc-logo.png"
import logo2 from "../../assets/images/Got-karnataka-black.png"
import elanziaLogo from "../../assets/images/elanzia.jpg"
import { isMobileDevice } from '../../utils/getPlatformInfo';
import dropdown from "../../assets/images/dropdown.png"

const stallJsonLinks = [
    {
        path: "./stallsData26/IIJS-2026.json",
        name: "hall1",
    },
];

/** Map catalog hall labels → venue + PlayCanvas hall id (used as Exhibitor_HallNo → hall{id}) */
const HALL_META = {
    Pavilion: { venue: "Jio", hallNo: "JWCC" },
    "LOTUS HALL": { venue: "Jio", hallNo: "JWCC" },
    JASMINE: { venue: "Jio", hallNo: "StallCLUB" },
    "HALL 2 - BEC": { venue: "Nesco", hallNo: "2" },
    "HALL 3 - BEC": { venue: "Nesco", hallNo: "3" },
    "HALL 4 - BEC": { venue: "Nesco", hallNo: "4" },
    "HALL 5 - BEC": { venue: "Nesco", hallNo: "5" },
    "HALL 6 - BEC": { venue: "Nesco", hallNo: "6" },
    "AURUM - BEC": { venue: "Nesco", hallNo: "aurum" },
};

/** Custom non-catalog stalls with GJEPC theme (3D entity name = key) */
const makeGjepcStall = (id, title, hallNo, venue = "Nesco", stallNo = id) => ({
    StallId__1: id,
    Exhibitor_Name: title,
    Exhibitor_StallNo1: stallNo,
    Exhibitor_Hall: String(hallNo),
    Exhibitor_HallNo: String(hallNo),
    venue,
    Exhibitor_Section: "",
    Catalog_Brief: "",
    Catalog_ProductLogo: [],
    customTheme: "gjepc",
    Search_Name: title,
    Catalog_CompanyLogo: `${window.location.origin}/textures/gjepc-logo.png`,
});

/** Same 3D entity name in both scenes — hall/venue follow active scene */
const getPrimePlusLounge = (sceneName = "JIO") => {
    const logo = `${window.location.origin}/textures/gjepc-logo.png`;
    if (String(sceneName).toUpperCase() === "NESCO") {
        return {
            ...makeGjepcStall("Prime_plus_lounge", "Prime Plus Lounge", "4", "Nesco"),
            Catalog_CompanyLogo: logo,
        };
    }
    return {
        ...makeGjepcStall("Prime_plus_lounge", "Prime Plus Lounge", "JWCC", "Jio"),
        Exhibitor_Hall: "LOTUS HALL",
        Catalog_CompanyLogo: logo,
    };
};

/** Innove8 exists in JWCC Pavilion (ground) and BEC Hall 6 */
const getInnove8 = (sceneName = "JIO") => {
    const logo = `${window.location.origin}/textures/gjepc-logo.png`;
    if (String(sceneName).toUpperCase() === "NESCO") {
        return {
            ...makeGjepcStall("Innove8", "Innove8", "6", "Nesco"),
            Catalog_CompanyLogo: logo,
        };
    }
    return {
        ...makeGjepcStall("Innove8", "Innove8", "JWCC", "Jio"),
        Exhibitor_Hall: "Pavilion",
        Catalog_CompanyLogo: logo,
    };
};

const CUSTOM_STALLS = {
    World_of_GJEPC: makeGjepcStall("World_of_GJEPC", "World of GJEPC", "3"),
    Business_Centre: makeGjepcStall("Business_Centre", "Business Centre", "4"),
    Central_Square: makeGjepcStall("Central_Square", "Central Square", "4"),
    Stall4T_512C: {
        Catalog_Address1: "",
        Catalog_Address2: "",
        Catalog_Address3: "",
        Catalog_City: "",
        Catalog_Pincode: "",
        Catalog_Fax: "",
        other_field_one: "",
        other_field_two: "",
        StallId__1: "Stall4T_512C",
        Exhibitor_StallType: "",
        Customer_No: 7000097392,
        Exhibitor_Name: "EBAY",
        Exhibitor_StallNo1: "4T 512C",
        "Exhibitor Code": "EXH2155",
        "Active Status": "Active",
        Exhibitor_Section: "Diamond, Gemstone, and Other Studded Jewellery",
        Exhibitor_DivisionNo: "4A",
        Exhibitor_Hall: "4",
        Exhibitor_StallNo1__1: "4T 512C",
        Exhibitor_Region: "RO-INTL",
        Area: 12,
        "Contact Person": "N/A",
        Catalog_Phone: "N/A",
        Catalog_Email: "N/A",
        Catalog_Brief: "eBay, the global e-commerce leader, connects millions of buyers and sellers around the world. For over two decades, eBay has empowered people to trade and grow businesses with a focus on trust and transparency in all transactions.",
        Brands: ["eBay"],
        product_dealing: [
            "Jewellery",
            "Gemstones",
            "Luxury Items",
            "Collectibles"
        ],
        "sub category": [
            "Rings",
            "Earrings",
            "Necklaces",
            "Bracelets"
        ],
        Catalog_ProductLogo: [
            // Use a placeholder/brand image if real product images are not available
            "https://d3lzcn6mbbadaf.cloudfront.net/media/details/ANI-20230905070913.jpg"
        ],
        Catalog_CompanyLogo: "https://d3lzcn6mbbadaf.cloudfront.net/media/details/ANI-20230905070913.jpg",
        venue: "Nesco",
        isPremier: 0,
    },
    Stall4T_512D: {
        Catalog_Address1: "",
        Catalog_Address2: "",
        Catalog_Address3: "",
        Catalog_City: "",
        Catalog_Pincode: "",
        Catalog_Fax: "",
        other_field_one: "",
        other_field_two: "",
        StallId__1: "Stall4T_512D",
        Exhibitor_StallType: "",
        Customer_No: 7000098702,
        Exhibitor_Name: "CATAWIKI",
        Exhibitor_StallNo1: "4T 512D",
        "Exhibitor Code": "EXH2158",
        "Active Status": "Active",
        Exhibitor_Section: "Diamond, Gemstone, and Other Studded Jewellery",
        Exhibitor_DivisionNo: "4A",
        Exhibitor_Hall: "4",
        Exhibitor_StallNo1__1: "4T 512D",
        Exhibitor_Region: "RO-INTL",
        Area: 12,
        "Contact Person": "N/A",
        Catalog_Phone: "N/A",
        Catalog_Email: "N/A",
        Catalog_Brief: "About Catawiki Catawiki is Europe’s leading online marketplace for special and rare objects that fulfill people’s passions. Founded in Amsterdam, the platform hosts weekly curated auctions featuring over 100,000 unique items across categories such as Jewellery, Watches, Art, Design, Classic Cars, and Collectibles. What sets Catawiki apart is its strong focus on expertise and trust: every object offered for sale is carefully selected and verified by one of Catawiki’s hundreds of in-house experts, many of whom are specialists in jewellery and luxury goods. This expert-led curation ensures quality, authenticity, and transparency for both buyers and sellers. Today, Catawiki connects millions of passionate buyers and professional sellers across more than 80 countries, making it a truly global marketplace for extraordinary objects. Visit catawiki.com or download the Catawiki app to discover weekly auctions.",
        Brands: ["Catawiki"],
        product_dealing: [
            "Silver Jewellery",
            "Lab Grown Jewellery",
            "Diamond Gemstones Jewellery",
            "Colour Gemstones",
            "Loose Diamonds",
            "Antique Jewellery",
            "Plain Gold Jewellery"
        ],
        "sub category": [
            "Rings",
            "Earrings",
            "Bracelets",
            "Necklaces"
        ],
        Catalog_ProductLogo: [
            "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776453502-42J1900825_3-(1).jpg",
            "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776454133-PXL_20220719_103008673-(1).jpg",
            "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776454332-R2780R18KW-(1-of-1).jpg"
        ],
        Catalog_CompanyLogo: "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776083354-Logo-Catawiki.jpg",
        venue: "Nesco",
        isPremier: 0,
    },
    
    Stall4T_512E: {
        Catalog_Address1: "",
        Catalog_Address2: "",
        Catalog_Address3: "",
        Catalog_City: "",
        Catalog_Pincode: "",
        Catalog_Fax: "",
        other_field_one: "",
        other_field_two: "",
        StallId__1: "Stall4T_512E",
        Exhibitor_StallType: "",
        Customer_No: 7000066056,
        Exhibitor_Name: "QuickSell (DoubleTick) WhatsApp Catalogue and Order Booking",
        Exhibitor_StallNo1: "4T 512E",
        "Exhibitor Code": "EXH2159",
        "Active Status": "Active",
        Exhibitor_Section: "Diamond, Gemstone, and Other Studded Jewellery",
        Exhibitor_DivisionNo: "4A",
        Exhibitor_Hall: "4",
        Exhibitor_StallNo1__1: "4T 512E",
        Exhibitor_Region: "HO-MUM (M)",
        Area: 9,
        "Contact Person": "N/A",
        Catalog_Phone: "N/A",
        Catalog_Email: "N/A",
        Catalog_Brief: "QuickSell (DoubleTick) is a powerful WhatsApp Catalogue and Order Booking platform, enabling businesses to quickly create and share digital catalogues seamlessly with their customers. Using QuickSell, brands can manage products, automate order collections, and facilitate faster, conversational commerce over WhatsApp. The platform is trusted by thousands of businesses in India to maximize sales efficiency in the high-touch jewellery market and other industries. Visit getsimpl.com or search for QuickSell (DoubleTick) on WhatsApp to experience instant catalogue sharing and ordering.",
        Brands: ["QuickSell", "DoubleTick"],
        product_dealing: [
            "Jewellery Digital Catalogues",
            "Order Booking Software",
            "Whatsapp Commerce Tools",
            "Product Sharing Solutions",
            "Business Automation"
        ],
        "sub category": [
            "Rings",
            "Necklaces",
            "Bracelets",
            "Earrings"
        ],
        Catalog_ProductLogo: [
            "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776453502-42J1900825_3-(1).jpg",
            "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776454133-PXL_20220719_103008673-(1).jpg",
            "https://cdn.gjepc.org/event/event-662a11334e6b6a4e2a320533/exh-frm/exhi-frm/1767776454332-R2780R18KW-(1-of-1).jpg"
        ],
        Catalog_CompanyLogo: "https://quickshell.org/favicon.svg",
        venue: "Nesco",
        isPremier: 0,
    },
    Stall4T_512F: {
        Catalog_Address1: "",
        Catalog_Address2: "",
        Catalog_Address3: "",
        Catalog_City: "",
        Catalog_Pincode: "",
        Catalog_Fax: "",
        other_field_one: "",
        other_field_two: "",
        StallId__1: "Stall4T_512F",
        Exhibitor_StallType: "",
        Customer_No: 7000050165,
        Exhibitor_Name: "DEE BEERS",
        Exhibitor_StallNo1: "4T 512F",
        "Exhibitor Code": "EXH2160",
        "Active Status": "Active",
        Exhibitor_Section: "Diamond, Gemstone, and Other Studded Jewellery",
        Exhibitor_DivisionNo: "4A",
        Exhibitor_Hall: "4",
        Exhibitor_StallNo1__1: "4T 512F",
        Exhibitor_Region: "HO-MUM (M)",
        Area: 12,
        "Contact Person": "N/A",
        Catalog_Phone: "N/A",
        Catalog_Email: "N/A",
        Catalog_Brief: "Founded in 1888 in South Africa, De Beers Group is the world’s leading diamond company, active across the diamond discovery and recovery pipeline with offices, operations and retail activity in 36 countries. We recover a third of the world’s rough diamonds from the deserts of southern Africa and the depths of the South Atlantic Ocean, to the Canadian Arctic, working alongside our joint venture partners in Botswana, Canada, Namibia and South Africa. We are the world’s leading diamond company. From the responsible discovery and recovery of diamonds to retail jewellery expertise, and from rough diamond sales to innovative diamond technology, we offer a range of industry-leading products.  Diamonds bring lasting, positive benefits to our communities. They reflect the beauty of the natural world, and signify the love, commitment and passion of everyone who gives and receives these timeless treasures of nature. Together with our joint venture partners, De Beers is powered by the passion",
        Brands: ["De Beers Group"],
        product_dealing: [
            "Wedding Jewellery",
            "Diamond Gemstones Jewellery",
            "Machinery"
        ],
        "sub category": [
            "Rings",
            "Bangles",
            "Earrings",
            "Pendants",
            "Bracelets",
            "Necklaces"
        ],
        Catalog_ProductLogo: [
            "https://cdn.gjepc.org/event/event-662a10ba4e6b6a4e2a320530/exh-frm/exhi-frm/1753444545277-DBG-LOGO-LED-Poster-screen-JCK-344x1032px.jpg"
        ],
        Catalog_CompanyLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/De_Beers_Logo.svg/3840px-De_Beers_Logo.svg.png",
        venue: "Nesco",
        isPremier: 0
    },
    // Hall 6
    Stall6G_047A: makeGjepcStall("Stall6G_047A", "WORLD GOLD COUNCIL PVT. LTD.", "6", "Nesco", "6G 047A"),
    Stall6L_086E: makeGjepcStall("Stall6L_086E", "GEMART", "6", "Nesco", "6L 086E"),
    "Stall_JIO-P_28a": makeGjepcStall("Stall_JIO-P_28a", "GI CRAFT PAVILION", "JWCC", "Jio"),
    "Stall_JIO-301": {...makeGjepcStall("Stall_JIO-301", "ELANZIA EXPERIENCE CENTRE", "StallCLUB", "Jio"), customTheme: "", Catalog_CompanyLogo: elanziaLogo, Catalog_ProductLogo:[elanziaLogo]},
};

/** Align catalog stall keys with 2026 scene entity names (StallJIO-x → Stall_JIO-x) */
const normalizeStallId = (id) =>
    String(id)
        .replace(/^StallJIO/i, "Stall_JIO")
        .replace(/^StallClub/i, "Stall_CLUB")
        .replace(/^StallCLUB/i, "Stall_CLUB")
        .replace(/^StallJio/i, "Stall_JIO");

const normalizeStallData = (data, sceneName = "JIO") => {
    if (!data || typeof data !== "object") return data;
    const out = {};
    Object.entries(data).forEach(([key, stall]) => {
        if (!stall) return;
        const meta = HALL_META[stall.Exhibitor_Hall] || {
            venue: stall.venue,
            hallNo: stall.Exhibitor_HallNo || stall.Exhibitor_Hall,
        };
        const stallId = normalizeStallId(key);
        const exhibitorName = String(stall.Exhibitor_Name || "");
        out[stallId] = {
            ...stall,
            StallId__1: stallId,
            venue: meta.venue,
            Exhibitor_HallNo: meta.hallNo,
            // Keep a readable hall label for the UI; HallNo drives 3D navigation
            Exhibitor_Hall: stall.Exhibitor_Hall,
            // Normalized name for search (strips punctuation that breaks Fuse extended search)
            Search_Name: exhibitorName
                .replace(/[^a-zA-Z0-9\s]/g, " ")
                .replace(/\s+/g, " ")
                .trim(),
        };
    });
    // Merge custom theme stalls (overrides catalog if same key)
    Object.entries(CUSTOM_STALLS).forEach(([id, stall]) => {
        out[id] = {
            ...stall,
            
        };
    });
    // Entity is named Prime_plus_lounge / Innove8 in BOTH JIO and BEC scenes
    out.Prime_plus_lounge = getPrimePlusLounge(sceneName);
    out.Innove8 = getInnove8(sceneName);
    return out;
};

const inputs = {
    productsCategory: [
        { name: "Antique Jewellery", type: "productsCategory", id: "antique" },
        { name: "Diamond Gemstones Jewellery", type: "productsCategory", id: "diamond" },
        { name: "Kundan Jewellery", type: "productsCategory", id: "kundan" },
        { name: "Lab Grown Diamond", type: "productsCategory", id: "kundan" },
        { name: "Loose Diamond", type: "productsCategory", id: "kundan" },
        { name: "Pearls", type: "productsCategory", id: "kundan" },
        { name: "Plain Gold Jewellery", type: "productsCategory", id: "kundan" },
        { name: "Platinum Jewellery", type: "productsCategory", id: "kundan" },
        { name: "Silver Jewellery", type: "productsCategory", id: "kundan" },
    ],
    subProductsCategory: [
        { name: "Ancle Bracelets(Payal)", type: "subProductsCategory", id: "bangles" },
        { name: "Bangles", type: "subProductsCategory", id: "bangles" },
        { name: "Bracelets", type: "subProductsCategory", id: "bracelet" },
        { name: "Chains", type: "subProductsCategory", id: "chains" },
        { name: "Designer Jewellery", type: "subProductsCategory", id: "chains" },
        { name: "Earrings", type: "subProductsCategory", id: "chains" },
        { name: "Loose Diamonds", type: "subProductsCategory", id: "chains" },
        { name: "Mangalsutra", type: "subProductsCategory", id: "chains" },
        { name: "Necklaces", type: "subProductsCategory", id: "chains" },
        { name: "Pendants", type: "subProductsCategory", id: "chains" },
    ]
}

const totalJsonToBeloaded = stallJsonLinks.length;

let listForFuse = null;
const options = {
    includeScore: false,
    shouldSort: true,
    minMatchCharLength: 2,
    threshold: 0.4,
    ignoreLocation: true,
    useExtendedSearch: true,
    keys: [
        "Exhibitor_Name",
        "Search_Name",
        "Exhibitor_StallNo1",
        "Exhibitor_Code",
        "Exhibitor_Section",
        "Exhibitor_Brand_Name",
        "sub category",
        "Any Other Product Category",
        "Any other Sub Product Category",
        "product_dealing",
        "Brands",
        "venue"
    ],
};

const scenes = [
    { name: "JIO", label: "JWCC" },
    { name: "NESCO", label: "BEC" },
]
const JIO_HALL = [
    { name: "hallJWCC", label: "Pavilion Floor" },
    { name: "hallStallCLUB", label: "Jasmine Hall / Lotus Hall" },
]

// Determine if the given scene is a JIO scene (where the JIO switcher should be visible)
const isJioScene = (scene) => scene.toUpperCase() === "JIO";

const Home = () => {
    const [canvasLoaded, setCanvasLoaded] = useState(true)
    const [list, setList] = useState(null)
    const [searchReady, setSearchReady] = useState(false)
    const fuse = useRef(null)
    const [productsCategory, setProductsCategory] = useState({})
    const [subProductsCategory, setsubProductsCategory] = useState({})
    const [showFilter, setShowFilter] = useState(false)
    const [scene, setScene] = useState("JIO")
    const sceneRef = useRef("JIO")
    const [loading, setLoading] = useState(false)
    const [jsonloadCount, setJsonloadCount] = useState(0)
    const [allJsonLoaded, setAllJsonLoaded] = useState(false)
    const [showStall, setShowStall] = useState(false)
    const [goToStallId, setgoToStallId] = useState(false)
    const goToStallRef = useRef(null)
    const [disabled, setDisabled] = useState(false);
    const [jioSwitchModal, setJioSwitchModal] = useState(false);
    const [currentJIOHall, setCurrentJIOHall] = useState(null);

    const handleSceneChange = (name, params = null, goToStall = null, stallData = null, checkSameScene = true) => {
        if (name == scene) {
            return;
        }
        if (disabled) {
            if (checkSameScene) {
                return
            } else {
            }
        }
        const changeSceneFn = window.changeScene || window.parent.changeScene;
        if (typeof changeSceneFn !== "function") {
            console.error("changeScene is not ready yet");
            return;
        }
        const previousScene = scene;
        setDisabled(true)
        setLoading(true)
        setJsonloadCount(0)
        setScene(name)
        sceneRef.current = name
        console.log(name.toUpperCase(),"try to load")
        changeSceneFn(name.toUpperCase(), (err) => {
            if (err) {
                console.error("changeScene failed:", err);
                setScene(previousScene);
                sceneRef.current = previousScene;
            } else {
                const primePlus = getPrimePlusLounge(name);
                const innove8 = getInnove8(name);
                setList((prev) => {
                    if (!prev) return prev;
                    const next = {
                        ...prev,
                        Prime_plus_lounge: primePlus,
                        Innove8: innove8,
                    };
                    if (window.parent.sendAllDataToPlaycanvas) {
                        window.parent.sendAllDataToPlaycanvas(next);
                    }
                    return next;
                });
            }
            if (params && !err) {
                if (goToStall) {
                    setgoToStallId(stallData)
                    goToStallRef.current = goToStall
                } else {
                    window.parent.highlightSingleCard(params.itemid, params.cardid, params.hallName, true)
                }
            }
            setCurrentJIOHall(null);
            setDisabled(false)
            setLoading(false)
        })
    }

    const handleChange = (e, type) => {
        if (type == "productsCategory") {
            setProductsCategory(prev => ({
                ...prev,
                [e.target.name]: e.target.checked
            }))
        } else {
            setsubProductsCategory(prev => ({
                ...prev,
                [e.target.name]: e.target.checked
            }))
        }
    }

    const handleAllJsonDataLoaded = () => {
        if (list != null) {
            setSearchReady(true)
            listForFuse = Object.values(list);
            fuse.current = new Fuse(listForFuse, options); //withOutIndex
        }
    };

    const handleSingleJsonLoad = (name) => {
        if (totalJsonToBeloaded == jsonloadCount + 1) {
            setAllJsonLoaded(true)
            handleAllJsonDataLoaded();
            setJsonloadCount(prev => prev + 1)
            setLoading(false)
        }
    };

    useEffect(() => {
        if (!list || Object.values(list).length === 0) return;
        if (goToStallId) {
            goToStallRef.current(goToStallId)
        }
        // Initial JSON load progress only — later list patches (e.g. scene switch)
        // must not re-open the loading overlay or they can stick forever.
        if (jsonloadCount < totalJsonToBeloaded) {
            handleSingleJsonLoad()
        } else {
            listForFuse = Object.values(list);
            fuse.current = new Fuse(listForFuse, options);
            setSearchReady(true)
        }
    }, [list])

    const handleJsonData = (name, data) => {
        if (data) {
            const normalized = normalizeStallData(data, sceneRef.current);
            setList(prev => ({
                ...prev,
                ...normalized
            }))
            if (window.parent.sendAllDataToPlaycanvas) {
                window.parent.sendAllDataToPlaycanvas(normalized);
                try {
                    window.ReactNativeWebView.postMessage("loaded");
                } catch (err) {
                    console.log("first");
                }
            } else {
                console.log("playcanvas function not found to load json");
            }
        } else {
            console.log("errrooorr");
        }
        setCanvasLoaded(true)
        setLoading(false)
    };

    const loadAllJsons = () => {
        stallJsonLinks.forEach(async ({ path, name }) => {
            const response = await fetch(path
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            )
                .then(function (response) {
                    return response.json()
                })
                .catch(err => {
                    console.log(err)
                })

            handleJsonData(name, response);
        });
    };

    const handleCanvasLoad = () => {
        loadAllJsons();
    }

    const handleSingleTab = (itemid = 4, cardid = 1, hallName = -1, _scene = "NESCO") => {
        if (scene === _scene) {
            window.parent.highlightSingleCard(itemid, cardid, hallName, true)
        } else {
            let params = {
                itemid,
                cardid,
                hallName,
                _scene
            }
            handleSceneChange(_scene, params)
        }
    }

    useEffect(() => {
        window.parent.singleTab = handleSingleTab
    }, [scene])

    useEffect(() => {
        window.parent.frontEndLinker = {
            handleCanvasLoad: handleCanvasLoad,
        };
    }, [])

    const handleModalClose = () => {
        setShowFilter(false)
    }

    const openJioSwitchModal = () => {
        setJioSwitchModal((prev) => !prev);
    }

    const switchJIOHall = (id) => {
        window.parent.goToHall(id, () => {
            setCurrentJIOHall(id)
        });
        if (currentJIOHall) {
            setJioSwitchModal(false);
            return;
        }
        openJioSwitchModal()
    }

    return (
        <div>
            {loading && <div className={styles.loading}>
                <div className="lds-dual-ring"></div></div>}
            {!isMobileDevice && <div className={styles.logoWrapper}>
                <img
                    className={styles.logo}
                    src={logo1}
                    style={{
                        top: "0px",
                        right: "0px",
                        position: "absolute",
                        width: "125px",
                        margin: "20px 0px",
                        zIndex: 2
                    }}
                />
                {/* <img
                    src={logo2}
                    style={{
                        backgroundColor: "#fff",
                        padding: "8px",
                        borderRadius: "5px",
                        boxSizing: "border-box",
                        top: "70px",
                        right: "0px",
                        position: "absolute",
                        width: "125px",
                        margin: "20px 0px",
                        zIndex: 2
                    }}
                /> */}
            </div>}
            {/* Only show hall switch when the current scene is JIO */}
            {list && currentJIOHall && isJioScene(scene) && (
                <div className={styles.switchScenes} style={{ right: "10rem" }}>
                    {JIO_HALL.map((_scene, index) => {
                        return currentJIOHall !== _scene.name
                            ? <div key={index} onClick={() => switchJIOHall(_scene.name)} style={{ background: "#000", border: "1px solid #fff", color: "#fff" }} className={styles.switchBtn}>{_scene.label}</div>
                            : null
                    })}
                </div>
            )}
            {list && <div className={styles.switchScenes}>
                {scenes.map((_scene, index) => {
                    return <div key={index} onClick={() => handleSceneChange(_scene.name)} style={_scene.name === scene ? { background: "#000", border: "1px solid #fff", color: "#fff" } : {}} className={styles.switchBtn}>{_scene.label}</div>
                })}
            </div>}
            {list && <div className={styles.dropdown}>{(Object.keys(productsCategory).filter((id) => productsCategory[id]).length > 0 ||
                Object.keys(subProductsCategory).filter((id) => subProductsCategory[id]).length > 0) && <div className={styles.filterIcon}></div>}<img onClick={() => setShowFilter(true)} src={dropdown} className={styles.dropdownSvg} /></div>}
            {showFilter &&
                <><div onClick={() => setShowFilter(false)} className={styles.modalOverlay}></div><div className={styles.modal}>
                    <div style={{ maxHeight: "50vh", overflow: "auto" }}>
                        <div className={styles.headname}>Products</div>
                        {inputs.productsCategory.map(input => {
                            return <div className={styles.checkboxWrapper}><input type="checkbox" className={styles.checkbox} name={input.name} checked={productsCategory[input.name]} onChange={(e) => handleChange(e, "productsCategory")} /><label>{input.name}</label></div>
                        })}
                        <div className={styles.headname}>Sub Products</div>
                        {inputs.subProductsCategory.map(input => {
                            return <div className={styles.checkboxWrapper}><input type="checkbox" className={styles.checkbox} name={input.name} checked={subProductsCategory[input.name]} onChange={(e) => handleChange(e, "subProductsCategory")} /><label>{input.name}</label></div>
                        })}
                    </div>
                    <button onClick={handleModalClose} className={styles.apply}>Apply</button>
                </div></>}

            {jioSwitchModal &&
                <><div onClick={() => setShowFilter(false)} className={styles.modalOverlay}></div><div className={`${styles.modal} ${styles.modal2}`}>
                    <div className={styles.modalInner}>
                        <div className={styles.headname}>Select Hall</div>
                        <div className={styles.modalButtonContainer}>
                            {JIO_HALL.map((item, index) => {
                                return <button key={index} onClick={() => switchJIOHall(item.name)} className={styles.apply}>{item.label}</button>
                            })}
                        </div>
                    </div>
                </div></>}

            {list && <Search openJioSwitchModal={openJioSwitchModal} showStall={showStall} handleSceneChange={handleSceneChange} scene={scene} handleCanvasLoad={handleCanvasLoad} productsCategory={productsCategory} subProductsCategory={subProductsCategory} list={list} fuse={fuse.current} setCurrentJIOHall={setCurrentJIOHall} />}
        </div>
    )
}

export default Home